import { imageUrl } from '@helpers/image';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import React from 'react';
import ReactPlayer from 'react-player/lazy';
import S from './FeatureVideo.styles';
const FeatureVideo = ({ content, cta, title, video, thumbnail, background, }) => {
    const videoOnly = !content && !title && !cta?.text;
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, { background: background, videoOnly: videoOnly },
            React.createElement(S.VideoWrapper, { videoOnly: videoOnly }, video && (React.createElement(ReactPlayer, { light: thumbnail ? imageUrl(thumbnail, {}) : true, url: video, playing: true, controls: true, width: "100%", height: "100%" }))),
            !videoOnly && (React.createElement(S.ContentWrapper, null,
                title && React.createElement(S.Title, null, title),
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                cta?.text && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { href: cta.url, target: cta.target, title: cta.text }))))))));
};
export default FeatureVideo;
